import { render, staticRenderFns } from "./MobileTopMenu.vue?vue&type=template&id=baf412ec"
import script from "./MobileTopMenu.vue?vue&type=script&lang=js"
export * from "./MobileTopMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports